<template>
  <main-layout
    class="purchaser-detail"
    page-title="采购商详情"
    custom-back
    @listen-back="goBack"
  >
    <div slot="main-content" class="main-content">
      <div class="main-info-box">
        <div class="avatar">
          <img :src="processAvatar(infoObj.imgUrl)" alt="" />
        </div>
        <div class="text">
          <div class="top">
            <div class="name">{{ infoObj.purName }}</div>
            <div class="tag" v-if="infoObj.identity">
              {{ identityMap[infoObj.identity] }}
            </div>
          </div>
          <div class="data">
            <div class="tag" :class="{ active: infoObj.passengerFlowNum }">
              客流量：{{ infoObj.passengerFlowNum }}
            </div>
            <div class="tag" :class="{ active: infoObj.followNum }">
              被关注：{{ infoObj.followNum }}
            </div>
            <div class="tag" :class="{ active: infoObj.consultNum }">
              咨询人数：{{ infoObj.consultNum }}
            </div>
          </div>
          <div class="look-license">
            <span>查看证照信息：</span>
            <div class="pic"></div>
          </div>
        </div>
        <div class="contact-btn" @click="openModal">
          <i class="iconfont icon-Call-ux"></i>立即联系
        </div>
      </div>
      <div class="intention-analysis">
        <div class="title">采购意向分析</div>
        <div class="box">
          <template v-if="infoObj.followVOList && infoObj.followVOList.length">
            <div class="tips">最近7天采购商在找以下农产品：</div>
            <div class="list">
              <div
                class="crop"
                v-for="(item, idx) in infoObj.followVOList"
                :key="idx"
              >
                <img class="pic" :src="item.imgUrl" alt="" />
                <div class="name">{{ item.secondName }}</div>
              </div>
            </div>
          </template>
          <template v-if="!infoObj.followVOList">
            <div class="no-list-data">
              <img
                :src="
                  require('../../assets/images/supplier/no-search-result.png')
                "
                alt=""
              />
              <div class="title">最近没有动态</div>
              <div class="subtitle">该采购商可能不太活跃</div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import { getPurchasDetail } from "@/api/request/snkd.purchase";
import { setImgUrl } from "@/utils";
import modal from "./mixins/modal";
export default {
  mixins: [modal],
  components: { MainLayout },
  data() {
    return {
      purId: null,
      supId: null,
      infoObj: {},
      defaultAvatar: require("@/assets/images/supplier/default-avatar.png"),
      identityMap: {
        1: "超市",
        2: "电商",
        3: "餐饮门店",
        4: "食品加工企业",
        5: "生鲜店",
        6: "其他",
        7: "经销商",
      },
    };
  },
  mounted() {
    const { purId, supId } = this.$route.query;
    this.purId = purId;
    this.supId = supId;
    this.getDetail();
  },
  methods: {
    async getDetail() {
      const res = await getPurchasDetail({
        purId: this.purId,
        supId: this.supId,
      });
      console.log("采购商详情===", res);
      if (res.respCode === 0) {
        this.infoObj = res.obj;
      }
    },
    processAvatar(path) {
      if (path) {
        return this.formatPic(path, 280);
      } else {
        return this.defaultAvatar;
      }
    },
    formatPic(path, size) {
      return setImgUrl(path, size, size);
    },
    goBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/style/download-guide-popup.scss";
</style>
<style scoped lang="scss">
.purchaser-detail {
  .main-content {
    width: 1200px;
    margin: 0 auto;
  }
  .main-info-box {
    position: relative;
    width: 100%;
    height: 200px;
    box-sizing: border-box;
    padding: 0 30px;
    display: flex;
    align-items: center;
    background: #ffffff;
    .avatar {
      width: 140px;
      height: 140px;
      margin-right: 20px;
      border-radius: 10px;
      border: 1px solid #e9eef5;
      overflow: hidden;
      > img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .text {
      .top {
        display: flex;
        align-items: center;
        .name {
          max-width: 750px;
          font-size: 22px;
          color: #333333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .tag {
          padding: 4px 10px;
          margin-left: 8px;
          font-size: 14px;
          color: #ffffff;
          border-radius: 15px 15px 15px 0;
          background: #ff7c12;
        }
      }
      .data {
        display: flex;
        margin-top: 18px;
        .tag {
          margin-right: 12px;
          padding: 6px 8px;
          color: #b2b2b2;
          font-size: 14px;
          border-radius: 4px;
          border: 1px solid #b2b2b2;
          &.active {
            color: #66bb6a;
            border-color: #66bb6a;
          }
        }
      }
      .look-license {
        visibility: hidden;
        height: 37px;
        display: flex;
        align-items: center;
        color: #666;
        font-size: 16px;
        margin-top: 22px;
        .pic {
          width: 52px;
          height: 37px;
          background-image: url("~@/assets/images/supplier/license.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          cursor: pointer;
          &:hover {
            background-image: url("~@/assets/images/supplier/license-hover.png");
          }
        }
      }
    }
    .contact-btn {
      position: absolute;
      right: 30px;
      top: 50%;
      transform: translateY(-50%);
      width: 140px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #ffffff;
      border-radius: 3px;
      background: #64c3a4;
      cursor: pointer;
      .iconfont {
        font-size: 20px;
      }
    }
  }
  .intention-analysis {
    width: 1200px;
    min-height: 554px;
    padding: 30px 32px;
    box-sizing: border-box;
    margin-top: 20px;
    background: #ffffff;
    .title {
      color: #333;
      font-size: 24px;
      line-height: 1.5;
      margin-bottom: 10px;
    }
    .box {
      .tips {
        font-size: 16px;
        color: #888888;
      }
      .list {
        display: flex;
        flex-wrap: wrap;
        margin-top: 24px;
        .crop {
          width: 146px;
          min-width: 146px;
          height: 158px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-right: 19px;
          margin-bottom: 35px;
          border-radius: 10px;
          background: #f7f9fb;
          &:nth-child(7n + 7) {
            margin-right: 0;
          }
          .pic {
            display: block;
            width: 68px;
            height: 68px;
          }
          .name {
            font-size: 14px;
            color: #666666;
            margin-top: 14px;
          }
        }
      }
      .no-list-data {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 128px;
        > img {
          width: 170px;
          height: 110px;
        }
        .title {
          color: #333;
          font-size: 18px;
          line-height: 24px;
          margin-top: 26px;
        }
        .subtitle {
          color: #999;
          text-align: center;
          font-size: 14px;
          margin-top: 12px;
        }
      }
    }
  }
}
</style>
